module.exports = __webpack_public_path__ + "img/arch-3.6213665d.svg";